"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.disposeAllSubscriptions = void 0;
/**
 * Loop through and dispose of all subscriptions when they are disposable
 * @param subscriptions
 * @return empty array
 */
function disposeAllSubscriptions(subscriptions) {
    if (Array.isArray(subscriptions)) {
        while (subscriptions.length > 0) {
            const subscription = subscriptions.pop();
            if (subscription === null || subscription === void 0 ? void 0 : subscription.unsubscribe) {
                subscription.unsubscribe();
            }
        }
    }
    return subscriptions;
}
exports.disposeAllSubscriptions = disposeAllSubscriptions;
//# sourceMappingURL=utilities.js.map